import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMobileServiceWorkflowsetsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetMobileServiceWorkflowsetsQuery = { __typename?: 'query_root', workflowsets: Array<{ __typename?: 'workflowsets', id: number, name: string, description: string, mobile_inspection_workflow_id?: number | null }> };


export const GetMobileServiceWorkflowsetsDocument = gql`
    query getMobileServiceWorkflowsets($customerId: bigint!) {
  workflowsets(where: {customer_id: {_eq: $customerId}}, order_by: {name: asc}) {
    id
    name
    description
    mobile_inspection_workflow_id
  }
}
    `;

/**
 * __useGetMobileServiceWorkflowsetsQuery__
 *
 * To run a query within a React component, call `useGetMobileServiceWorkflowsetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileServiceWorkflowsetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileServiceWorkflowsetsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetMobileServiceWorkflowsetsQuery(baseOptions: Apollo.QueryHookOptions<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables> & ({ variables: GetMobileServiceWorkflowsetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>(GetMobileServiceWorkflowsetsDocument, options);
      }
export function useGetMobileServiceWorkflowsetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>(GetMobileServiceWorkflowsetsDocument, options);
        }
// @ts-ignore
export function useGetMobileServiceWorkflowsetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>;
export function useGetMobileServiceWorkflowsetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceWorkflowsetsQuery | undefined, GetMobileServiceWorkflowsetsQueryVariables>;
export function useGetMobileServiceWorkflowsetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>(GetMobileServiceWorkflowsetsDocument, options);
        }
export type GetMobileServiceWorkflowsetsQueryHookResult = ReturnType<typeof useGetMobileServiceWorkflowsetsQuery>;
export type GetMobileServiceWorkflowsetsLazyQueryHookResult = ReturnType<typeof useGetMobileServiceWorkflowsetsLazyQuery>;
export type GetMobileServiceWorkflowsetsSuspenseQueryHookResult = ReturnType<typeof useGetMobileServiceWorkflowsetsSuspenseQuery>;
export type GetMobileServiceWorkflowsetsQueryResult = Apollo.QueryResult<GetMobileServiceWorkflowsetsQuery, GetMobileServiceWorkflowsetsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getMobileServiceWorkflowsets.query.gql}
 */
export async function getMobileServiceWorkflowsets(
  variables: GetMobileServiceWorkflowsetsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMobileServiceWorkflowsetsQuery['workflowsets']>
export async function getMobileServiceWorkflowsets(
  variables: GetMobileServiceWorkflowsetsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMobileServiceWorkflowsetsQuery>
export async function getMobileServiceWorkflowsets(
  variables: GetMobileServiceWorkflowsetsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMobileServiceWorkflowsetsQuery['workflowsets'] | GetMobileServiceWorkflowsetsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMobileServiceWorkflowsetsQuery>(
    GetMobileServiceWorkflowsetsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.workflowsets
}